import { NavLink } from 'react-router-dom';

export const Breadcrumbs = (props) => {
	return (
		<>
			<div className="breadcrumbs">
				<div className="breadcrumbs__container container">
					<ul className="breadcrumbs__list">
						<li className="breadcrumbs__item"><NavLink to="/">Home</NavLink></li>
						<li className="breadcrumbs__item">{ props.value }</li>
					</ul>
				</div>
			</div>
		</>
	)
}